import {
  StringOrNullOrUndefined,
  NumberOrNullOrUndefined,
} from 'src/app/shared/utils';

export class LocationV2 {
  id: number = 0;
  title: string = '';
  avatar?: string;
  city: string = '';
  state: string = '';
  zip?: number;
  address?: string;
  address2?: string;
  email?: string;
  contact_email?: string;
  contact_phone?: string;
  phone1?: string;
  phone2?: string;
  telfax?: string;
  taxid?: string;
  npi?: string;
  taxonomy?: string;
  providerId?: string;
  additional_notes?: string;
  link_documentation?: string;
  pay_group_code_1099?: string;
  pay_group_code_w2?: string;
  status?: string;
  note_backdating_limit_hours?: number;
  document_notification_settings?: Record<string, boolean>;
  missing_notes_notification_settings?: {
    email_enabled: boolean;
    sms_enabled: boolean;
  };
  created_at?: string | Date;
  updated_at?: string | Date;
  deleted_at?: string | Date;

  constructor(data: Partial<LocationV2> = {}) {
    this.id = NumberOrNullOrUndefined(data.id) ?? 0;
    this.title = StringOrNullOrUndefined(data.title) ?? '';
    this.avatar = StringOrNullOrUndefined(data.avatar);
    this.city = StringOrNullOrUndefined(data.city) ?? '';
    this.state = StringOrNullOrUndefined(data.state) ?? '';
    this.zip = NumberOrNullOrUndefined(data.zip);
    this.address = StringOrNullOrUndefined(data.address);
    this.address2 = StringOrNullOrUndefined(data.address2);
    this.email = StringOrNullOrUndefined(data.email);
    this.contact_email = StringOrNullOrUndefined(data.contact_email);
    this.contact_phone = StringOrNullOrUndefined(data.contact_phone);
    this.phone1 = StringOrNullOrUndefined(data.phone1);
    this.phone2 = StringOrNullOrUndefined(data.phone2);
    this.telfax = StringOrNullOrUndefined(data.telfax);
    this.taxid = StringOrNullOrUndefined(data.taxid);
    this.npi = StringOrNullOrUndefined(data.npi);
    this.taxonomy = StringOrNullOrUndefined(data.taxonomy);
    this.providerId = StringOrNullOrUndefined(data.providerId);
    this.additional_notes = StringOrNullOrUndefined(data.additional_notes);
    this.link_documentation = StringOrNullOrUndefined(data.link_documentation);
    this.pay_group_code_1099 = StringOrNullOrUndefined(data.pay_group_code_1099);
    this.pay_group_code_w2 = StringOrNullOrUndefined(data.pay_group_code_w2);
    this.status = StringOrNullOrUndefined(data.status);
    this.note_backdating_limit_hours = NumberOrNullOrUndefined(data.note_backdating_limit_hours);
    this.document_notification_settings = data.document_notification_settings;
    this.missing_notes_notification_settings = data.missing_notes_notification_settings ?? {
      email_enabled: true,
      sms_enabled: false,
    };
    this.created_at = data.created_at ? new Date(data.created_at) : undefined;
    this.updated_at = data.updated_at ? new Date(data.updated_at) : undefined;
    this.deleted_at = data.deleted_at ? new Date(data.deleted_at) : undefined;
  }
}
